module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-7f623d24.png";